import type { ChannelCatalogResponse, SeriesEpisodesResponse } from '@apm/contracts';
import { config } from './config.js';

/**
 * v39 카탈로그 (`GET /v1/channels/{channelId}/catalog` · `…/catalog/series/{seriesId}` · `docs/81` §3).
 *
 * **조망이다** — 응답으로는 아무것도 재생하지 않는다(규칙 105). 고르면 `selectItem(productId)` 가 서버의 `/playlist` 를
 * 다시 받는다. 시청자별 값이 없어 토큰을 싣지 않는다.
 *
 * **던지지 않는다 — 실패는 `null`** 이다(`fetchLineup` 과 같은 방침). `null` 은 「들고 있던 것을 덮어쓰지 말라」이고, 시트는
 * 카탈로그가 없으면 지금의 평면 목록으로 선다(`contentSheetMode` · D8). 실패는 조용하지 않게 시트 머리의 한 줄이 말한다.
 */
export async function fetchCatalog(
  channelId: string,
  signal?: AbortSignal,
): Promise<ChannelCatalogResponse | null> {
  return getJson<ChannelCatalogResponse>(
    `/v1/channels/${encodeURIComponent(channelId)}/catalog`,
    signal,
  );
}

export async function fetchSeriesEpisodes(
  channelId: string,
  seriesId: string,
  signal?: AbortSignal,
): Promise<SeriesEpisodesResponse | null> {
  return getJson<SeriesEpisodesResponse>(
    `/v1/channels/${encodeURIComponent(channelId)}/catalog/series/${encodeURIComponent(seriesId)}`,
    signal,
  );
}

async function getJson<T>(path: string, signal?: AbortSignal): Promise<T | null> {
  const base = config.serverUrl.replace(/\/+$/, '');
  try {
    const response = await fetch(`${base}${path}`, signal ? { signal } : {});
    if (!response.ok) return null;
    return (await response.json()) as T;
  } catch {
    return null;
  }
}
